/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Profile_Locale_Defaulthint1Inputs */

const he_profile_locale_defaulthint1 = /** @type {(inputs: Profile_Locale_Defaulthint1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`כרגע: ${i?.locale}`)
};

const en_profile_locale_defaulthint1 = /** @type {(inputs: Profile_Locale_Defaulthint1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Currently: ${i?.locale}`)
};

/**
* | output |
* | --- |
* | "Currently: {locale}" |
*
* @param {Profile_Locale_Defaulthint1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const profile_locale_defaulthint1 = /** @type {((inputs: Profile_Locale_Defaulthint1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Locale_Defaulthint1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_locale_defaulthint1(inputs)
	return en_profile_locale_defaulthint1(inputs)
});
export { profile_locale_defaulthint1 as "profile_locale_defaultHint" }